import React from 'react';

const YOUR_PHONE = '9159933276'; // உங்கள் phone number இங்கே போடுங்கள்
const YOUR_UPI = 'manikj729@oksbi'; // உங்கள் UPI ID இங்கே போடுங்கள்

function TrialExpired() {
  const [currentPlan,  setCurrentPlan]  = React.useState('trial');
  const [monthlyPrice, setMonthlyPrice] = React.useState(299);
  const [userName,     setUserName]     = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/auth/me', {
      headers: { 'Authorization': 'Bearer ' + token }
    })
    .then(r => r.json())
    .then(data => {
      setCurrentPlan(data.account_type  || 'trial');
      setMonthlyPrice(data.monthly_price || 299);
      setUserName(data.name || '');
    })
    .catch(() => {});
  }, []);

  const sendWhatsApp = () => {
    const msg = "Hello, நான் StockApp payment பண்ணினேன். Screenshot அனுப்புகிறேன்.";
    window.open(`https://wa.me/91${YOUR_PHONE}?text=${encodeURIComponent(msg)}`, '_blank');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1>⏰ Free Trial முடிந்தது!</h1>
        <p style={styles.subtitle}>தொடர்ந்து உபயோகிக்க ₹299/month மட்டும்!</p>

        {/* Benefits */}
        <div style={styles.benefits}>
          <p>✅ Unlimited Stock Management</p>
          <p>✅ Billing + WhatsApp Invoice</p>
          <p>✅ Reports</p>
          <p>✅ Local Madurai Support</p>
        </div>

        {/* Payment Box */}
        <div style={styles.paymentBox}>
          <h3>💳 Payment பண்ணுங்கள்</h3>
          <p style={styles.upiId}>UPI ID: {YOUR_UPI}</p>
          <p style={styles.amount}>₹299 / month</p>
          <p style={styles.note}>
            ⚠️ Payment பண்ணிய பிறகு screenshot இந்த number-க்கு
            WhatsApp பண்ணுங்கள்:
          </p>
          <p style={styles.phone}>📱 +91 {YOUR_PHONE}</p>
        </div>

        {/* WhatsApp Button */}
        <button style={styles.whatsappBtn} onClick={sendWhatsApp}>
          📱 WhatsApp-ல் Screenshot அனுப்பு
        </button>

        <p style={styles.footer}>
          உங்கள் account 2 மணி நேரத்தில் activate ஆகும்! 🎉
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#f0f2f5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  card: {
    backgroundColor: 'white',
    padding: '40px',
    borderRadius: '15px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '400px',
    textAlign: 'center',
  },
  subtitle: { color: '#666', fontSize: '16px' },
  benefits: {
    backgroundColor: '#f0f9f0',
    padding: '15px',
    borderRadius: '10px',
    margin: '20px 0',
    textAlign: 'left',
  },
  paymentBox: {
    backgroundColor: '#fff3cd',
    padding: '20px',
    borderRadius: '10px',
    margin: '20px 0',
    border: '1px solid #ffc107',
  },
  upiId: {
    fontSize: '16px',
    fontWeight: 'bold',
    color: '#2c3e50',
    backgroundColor: '#ecf0f1',
    padding: '10px',
    borderRadius: '5px',
  },
  amount: { fontSize: '28px', fontWeight: 'bold', color: '#2ecc71' },
  note: { fontSize: '13px', color: '#666', marginTop: '10px' },
  phone: { fontSize: '18px', fontWeight: 'bold', color: '#2c3e50' },
  whatsappBtn: {
    backgroundColor: '#25D366',
    color: 'white',
    padding: '15px',
    border: 'none',
    borderRadius: '10px',
    fontSize: '16px',
    cursor: 'pointer',
    width: '100%',
    marginTop: '10px',
  },
  footer: { color: '#666', fontSize: '13px', marginTop: '15px' },
};

export default TrialExpired;

